export type TrainingLevel = 'low' | 'medium' | 'high'

export function trainingControls(kind: 'la' | 'cloze', difficulty: TrainingLevel, importance: TrainingLevel) {
  if (difficulty === 'high' || importance === 'high') return { primary: 'voice', reveal: false, voice: true } as const
  if (difficulty === 'low' || importance === 'low') {
    return { primary: 'reveal', reveal: true, voice: difficulty === 'low' && importance === 'low' } as const
  }
  return { primary: kind === 'la' ? 'voice' : 'reveal', reveal: true, voice: true } as const
}
